module.exports = __webpack_public_path__ + "img/bgPump.1b130a95.png";